
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import UntersuchungenDatatable from '@/components/Impfverwaltung/Untersuchungen/UntersuchungenDatatable.vue';
    import PatUntersuchung from '@/types/PatUntersuchung';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import Einsendeformular from '@/components/Einsendeformular.vue';
    import Patient from '@/types/Patient';
    import {confirmSwal} from '@/helper/swals';

    @Component({
        components: {
            UntersuchungenDatatable,
            Einsendeformular
        },
        computed: {
            ...mapState('patient', ['patientData', 'loaders', 'dt_load', 'dialogs', 'untersuchungen']),
            ...mapGetters('patient', ['getUntersuchungen']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('patient', [
                'printUntersuchung',
                'printUntersuchungMitBefund',
                'sendUntersuchungMitBefund',
                'printUntersuchungsanforderung'
            ]),
            ...mapMutations('patient', ['setDialogUntersuchung']),
        },
    })
    export default class UntersuchungenTabitem extends Vue {
        public untersuchungen!: PatUntersuchung[];
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public showEinsendeformular = false;
        public printUntersuchungsanforderung!: (payload: { patient:Patient, untersuchungen: PatUntersuchung[], onlytoday: boolean }) => void;

        public selected: PatUntersuchung[] = [];

        public reset(): void {
            this.selected = [];
        }

        public get selectedGleichesAbnahmedatum(): boolean {
            const unique = new Set(this.selected.map((untersuchung) => untersuchung.abnahmedatum));
            return unique.size === 1;
        }

        @Watch('dialogs.untersuchung')
        public onChangeDialogsUntersuchung(visible: boolean): void {
            if (!visible) {
                this.reset();
            }
        }

        public setShowEinsendeformular(value: boolean) {
            this.showEinsendeformular = value;
        }

        public onClickUntersuchungsanforderung(patientData: Patient, selected: PatUntersuchung[]) {
            var onlyToday = true;

            selected.forEach((untersuchung: PatUntersuchung) => {
                selected.forEach((item: PatUntersuchung) => {
                    if (untersuchung.abnahmedatum !== item.abnahmedatum) {
                        onlyToday = false;
                    }
                });
            });

            if (!onlyToday) {
                confirmSwal(
                    'Achtung!',
                    'Unterschiedliches Abnahmedatum! Möchten Sie trotzdem drucken?',
                ).then(({ isConfirmed }) => {
                    if (isConfirmed) {
                        this.printUntersuchungsanforderung({patient: patientData, untersuchungen: selected, onlytoday: false});
                    }
                });
            } else {
                this.printUntersuchungsanforderung({patient: patientData, untersuchungen: selected, onlytoday: true});
            }
        }
    }
